module.exports = __webpack_public_path__ + "media/assets/avatar-d005a792158459d829a539d6247fd1cf.png";